export const RISKFACTOR_LIST = 'src/components/RiskFactor/List/action/riskFactor_List';
export const RISKFACTOR_LIST_SUCCESS = 'src/components/RiskFactor/List/action/riskFactor_List_Success';
export const RISKFACTOR_LIST_FAILURE = 'src/components/RiskFactor/List/action/riskFactor_List_Failure';

export const riskFactorList = () => {
    return {
        type: RISKFACTOR_LIST,
    }
}
export const riskFactorListSuccess = (data) => {
    return {
        type: RISKFACTOR_LIST_SUCCESS,
        data
    }
}
export const riskFactorListFailure = (data) => {
    return {
        type: RISKFACTOR_LIST_FAILURE,
        data
    }
}

export const DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE = 'src/components/RiskFactor/List/action/Download_Edit_Risk_Factor_Template';
export const DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS = 'src/components/RiskFactor/List/action/Download_Edit_Risk_Factor_Template_Success';
export const DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE = 'src/components/RiskFactor/List/action/Download_Edit_Risk_Factor_Template_Failure';

export const downloadEditRiskFactorTemplate = () => {
    return {
        type: DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE,
    }
}
export const downloadEditRiskFactorTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadEditRiskFactorTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE,
        data
    }
}

export const UPLOAD_EDIT_RISK_FACTOR_TEMPLATE = 'src/components/RiskFactor/List/action/Upload_Edit_Risk_Factor_Template';
export const UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS = 'src/components/RiskFactor/List/action/Upload_Edit_Risk_Factor_Template_Success';
export const UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE = 'src/components/RiskFactor/List/action/Upload_Edit_Risk_Factor_Template_Failure';

export const uploadEditRiskFactorTemplate = (data) => {
    return {
        type: UPLOAD_EDIT_RISK_FACTOR_TEMPLATE,
        data
    }
}
export const uploadEditRiskFactorTemplateSuccess = (data) => {
    return {
        type: UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_SUCCESS,
        data
    }
}
export const uploadEditRiskFactorTemplateFailure = (data) => {
    return {
        type: UPLOAD_EDIT_RISK_FACTOR_TEMPLATE_FAILURE,
        data
    }
}